import Vue from 'vue'
import App from './App.vue'
import router from './router'

import plugins from './plugins' // plugins

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/style/calc.less'

import store from './store'
import TDesign from 'tdesign-vue';
import { download } from '@/utils/request'
import Help from '@/components/Help.vue'
import FileView from '@/components/FileView.vue'
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree,handleTreeSecond,changeNumMoneyToChinese,fileOpen } from "@/utils/ruoyi";
import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
import { getClassification } from "@/api/classification";


Vue.config.productionTip = false

Vue.prototype.download = download
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Help', Help)
Vue.component('FileView', FileView)

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.handleTreeSecond = handleTreeSecond
Vue.prototype.fileOpen = fileOpen
Vue.prototype.listFile = listFile
Vue.prototype.listRate = listRate
Vue.prototype.getClassification = getClassification

Vue.prototype.changeNumMoneyToChinese = changeNumMoneyToChinese

import 'tdesign-vue/es/style/index.css';
import '@/assets/font/font.css';
Vue.use(TDesign);
Vue.use(plugins)
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
